import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { getFromLocalStorage, LS_KEYS } from '../helpers/window';
import { selectors as authSelectors } from '../store/slices/authSlice';
// @ts-expect-error - customer slice being a js file
import { selectors as customerSelectors } from '../store/slices/customerSlice';

/**
 * This hook returns the userid/anonymous id either from loggedin account id or from local storage
 * @returns When not logged in, userid/anonymous id to identify a website user uniquely from local storage
 * @returns When logged in, userid (account.id) id to identify the loggedin website user uniquely
 * @example Always put a null check and use the hook: {userId} = useUserId(); if(userId) { ...do something}
 */

export const useUniqueUserIdentity = () => {
  const [userId, setUserId] = useState<string>('');
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const isLoggedIn: boolean = useSelector(authSelectors.isLoggedIn);
  const accountId: string = useSelector(customerSelectors.getAccountId);

  useEffect(() => {
    const uniqeId = isLoggedIn ? accountId : getFromLocalStorage(LS_KEYS.ANONYMOUS_ID);
    if (uniqeId) setUserId(uniqeId);
  }, [isLoggedIn, accountId]);

  useEffect(() => {
    if (userId) setIsLoaded(true);
  }, [userId]);

  return {
    userId,
    isLoaded,
  };
};
